<template>
  <div class="myintroduceBox">
    <div class="introduceTitle">故宫博物院</div>
    <div class="introduceTitle2">作者:xxx</div>
    <div class="introduceTitle2">时间:2024-05-05</div>

    <div class="mainbox">
      <p class="mytextp">
        故宫博物院成立于1925年10月10日，是在明清皇宫及其收藏基础上建立起来的大型综合性古代艺术博物馆。故宫于1961年被国务院列为第一批“全国重点文物保护单位”，1987年被联合国教科文组织列入“世界遗产名录”。故宫博物院于2007年被评为国家5A级旅游景区，2008年被评为首批国家一级博物馆。
        故宫博物院占地100余万平方米，保存古建筑约9000间，是我国现存规模最大、保存最完整的古代宫殿建筑群。故宫的前身是明清皇宫紫禁城，于明永乐十八年（1420年）建成，明清两代共有24位皇帝居住于此。1912年溥仪退位后，紫禁城作为皇宫的历史就此终结。1914年，于外朝区域成立古物陈列所；1925年，于内廷区域成立故宫博物院；1948年，古物陈列所并入故宫博物院。故宫博物院院藏文物体系完备，现有藏品总量186万余件（套），依据不同质地和形式，可分为绘画、法书、碑帖、铜器、金银器等25大类，其中珍贵文物占藏品总数的90%。故宫博物院通过明清皇家宫殿建筑，宫廷史迹原状陈列，珍宝、钟表、书画、陶瓷、雕塑等艺术藏品常设展览，以及临时特展等多种方式向公众展现悠久灿烂的中华文明。
      </p>
      <p class="mytextp">
        故宫为中国明、清两代（1368年—1912年）的皇宫，依照中国古代星象学说，紫微垣（即北极星）位于中天，乃天帝所居，天人对应，所以故宫又称紫禁城。明代第三位皇帝朱棣在夺取帝位后，决定迁都北京，明永乐四年（1406年），开始以南京故宫为蓝本营造宫殿 [30]，兴建北京皇宫和城垣。朱棣先派出人员，奔赴全国各地开采名贵的木材和石料，然后运送到北京。采集的物资包括来自四川的楠木、来自房山等地的丹陛石、来自苏州的金砖、来自临清的贡砖等。至明永乐十八年（1420年）落成。
        明末李自成撤离时，紫禁城仅剩武英殿、建极殿、英华殿、南薰殿、皇极门及角楼等少数建筑侥幸未毁。清朝定鼎北京后，即逐渐展开修复工作。随着“康乾盛世”的到来，紫禁城修缮迎来最为辉煌的历史时期。康熙改元之初，工程尚少。迨其亲政，大规模修缮随即展开。具体进程大致以“三藩之乱”平定为界，分康熙八年（1669年）至十三年、二十二年至三十七年两个大的阶段。康熙二十一年（1682年）二月，工部以太和殿“为天下万国之观瞻，必应修造”，疏请筹办物料。九月，清廷派员赴江浙、湖广、四川等省采办楠木，开始备料。康熙二十二年（1683年），国家统一大业基本完成，太和殿的兴修具有了全新的政治意义，筹建进一步提速。四川、湖广、江浙等地将所需木料通过水运北输至通州木厂。康熙三十七年（1698年）正月，工部题请赏赐，表明主体工程基本完成。迨清高宗继位，经济繁荣，财力充裕，国势达到“康乾盛世”的高峰，紫禁城内再次大兴土木。不但康熙时期的原有建筑得到维修，新建筑也不断增多，重要者如寿康宫、重华宫、建福宫及花园、雨花阁、中正殿、寿安宫、慈宁宫及花园、宁寿宫及花园、文渊阁、毓庆宫、乾清宫等等，一举奠定了清代紫禁城的全盛风貌。嘉道以降，内忧外患频繁，国势日衰，清廷对紫禁城基本上以维持为主，再无重大作为。 [35]
        宣统三年（1911年），辛亥革命胜利后，溥仪宣布退位，根据当时临时革命政府拟定的《清室优待条件》，逊帝溥仪被允许“暂居宫禁”，即紫禁城后部的“后寝（内廷）”。当时的政府决定，将热河（承德）行宫（即承德避暑山庄）和盛京（沈阳）故宫的文物移至故宫前半部的“前朝（外朝）”部分，修建有宝蕴楼，于民国三年（1914年）成立了古物陈列所。 [1] [107]溥仪居宫内，一直与亡清残余势力图谋复辟，且以赏赐、典当、修补等名目，从宫中盗窃大量文物，引起了社会各界的严重关注。
      </p>
      <div class="mainboximg">
        <img src="../assets/fhobnjtvfckx1hz2t8bq.jpg" class="mainboximg" alt />
      </div>
      <p class="mytextp">
        故宫为中国明、清两代（1368年—1912年）的皇宫，依照中国古代星象学说，紫微垣（即北极星）位于中天，乃天帝所居，天人对应，所以故宫又称紫禁城。明代第三位皇帝朱棣在夺取帝位后，决定迁都北京，明永乐四年（1406年），开始以南京故宫为蓝本营造宫殿 [30]，兴建北京皇宫和城垣。朱棣先派出人员，奔赴全国各地开采名贵的木材和石料，然后运送到北京。采集的物资包括来自四川的楠木、来自房山等地的丹陛石、来自苏州的金砖、来自临清的贡砖等。至明永乐十八年（1420年）落成。
        明末李自成撤离时，紫禁城仅剩武英殿、建极殿、英华殿、南薰殿、皇极门及角楼等少数建筑侥幸未毁。清朝定鼎北京后，即逐渐展开修复工作。随着“康乾盛世”的到来，紫禁城修缮迎来最为辉煌的历史时期。康熙改元之初，工程尚少。迨其亲政，大规模修缮随即展开。具体进程大致以“三藩之乱”平定为界，分康熙八年（1669年）至十三年、二十二年至三十七年两个大的阶段。康熙二十一年（1682年）二月，工部以太和殿“为天下万国之观瞻，必应修造”，疏请筹办物料。九月，清廷派员赴江浙、湖广、四川等省采办楠木，开始备料。康熙二十二年（1683年），国家统一大业基本完成，太和殿的兴修具有了全新的政治意义，筹建进一步提速。四川、湖广、江浙等地将所需木料通过水运北输至通州木厂。康熙三十七年（1698年）正月，工部题请赏赐，表明主体工程基本完成。迨清高宗继位，经济繁荣，财力充裕，国势达到“康乾盛世”的高峰，紫禁城内再次大兴土木。不但康熙时期的原有建筑得到维修，新建筑也不断增多，重要者如寿康宫、重华宫、建福宫及花园、雨花阁、中正殿、寿安宫、慈宁宫及花园、宁寿宫及花园、文渊阁、毓庆宫、乾清宫等等，一举奠定了清代紫禁城的全盛风貌。嘉道以降，内忧外患频繁，国势日衰，清廷对紫禁城基本上以维持为主，再无重大作为。 [35]
        宣统三年（1911年），辛亥革命胜利后，溥仪宣布退位，根据当时临时革命政府拟定的《清室优待条件》，逊帝溥仪被允许“暂居宫禁”，即紫禁城后部的“后寝（内廷）”。当时的政府决定，将热河（承德）行宫（即承德避暑山庄）和盛京（沈阳）故宫的文物移至故宫前半部的“前朝（外朝）”部分，修建有宝蕴楼，于民国三年（1914年）成立了古物陈列所。 [1] [107]溥仪居宫内，一直与亡清残余势力图谋复辟，且以赏赐、典当、修补等名目，从宫中盗窃大量文物，引起了社会各界的严重关注。
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.myintroduceBox {
  height: 100%;
  width: 100%;
  /* background-color: aqua; */
  padding: 0 10px;
}
.introduceTitle {
  height: 50px;
  width: 100%;
  font-weight: 800;
  font-size: 20px;
  line-height: 50px;
  text-align: center;
}
.introduceTitle2 {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #7c7c7c;
}
.mainbox {
  margin-top: 10px;
}
.mainboximg {
  width: 100%;
}
.mytextp {
  margin-bottom: 10px;
}
</style>